import React from 'react'
import ListGroup from 'react-bootstrap/ListGroup'
import { faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { ActionButton, IconButton } from 'shared/buttons'
import CardLoading from 'shared/card-loading'
import CardError from 'shared/card-error'

const ConversationList = ({ query, activeId, onSelect, onNew, onDelete, disabled }) => {
  const conversations = query.data?.conversations ?? []

  return (
    <div data-testid="ask-conversations">
      <ActionButton
        icon={faPlus}
        label="New question"
        variant="light"
        className="w-100 mb-3 border text-primary"
        onClick={onNew}
        disabled={disabled}
        data-testid="ask-new"
      />
      {query.isLoading && <CardLoading minHeight={120} />}
      {query.isError && <CardError title="Couldn't load your questions" onRetry={query.refetch} />}
      {!query.isLoading && !query.isError && conversations.length === 0 && (
        <p className="small text-muted" data-testid="ask-conversations-empty">Your questions will appear here.</p>
      )}
      {conversations.length > 0 && <div className="small text-muted text-uppercase fw-semibold mb-2 px-2">Recent</div>}
      <ListGroup variant="flush">
        {conversations.map((conversation) => (
          // A div, not ListGroup's action <button>: the row holds its own delete button.
          <ListGroup.Item
            key={conversation.id}
            as="div"
            role="button"
            tabIndex={0}
            aria-current={conversation.id === activeId ? 'true' : undefined}
            onClick={() => !disabled && onSelect(conversation.id)}
            // Only the row's own key press: Enter on the delete button inside it bubbles up here too.
            onKeyDown={(event) =>
              event.target === event.currentTarget && event.key === 'Enter' && !disabled && onSelect(conversation.id)
            }
            className={`list-group-item-action border-0 rounded-2 mb-1 py-2 px-2 d-flex align-items-center justify-content-between gap-2 small ${
              conversation.id === activeId ? 'bg-light fw-semibold text-primary border-start border-3 border-primary' : 'text-body'
            }`}
            data-testid={`ask-conversation-${conversation.id}`}
          >
            <span className="text-truncate">{conversation.preview || 'New question'}</span>
            <IconButton
              icon={faTrash}
              title="Delete"
              aria-label="Delete conversation"
              className="border-0 bg-transparent"
              iconClassName="text-muted"
              hoverClassName="border-0 bg-transparent"
              disabled={disabled}
              onClick={(event) => {
                event.stopPropagation()
                onDelete(conversation.id)
              }}
              data-testid={`ask-delete-${conversation.id}`}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  )
}

export default ConversationList
